import { getUser } from '../apis/user';
import { Organisation } from '../enums/common';
import { getOrganisation } from './common';
import { getCookieHelpers } from './cookie';
import { isLoggedIn } from './login';

export const getUserInfo = async () => {
    if (getOrganisation() !== Organisation.IXIGO) return undefined;

    const loggedIn = isLoggedIn();
    if (!loggedIn) return undefined;

    const userInfo = localStorage.getItem('userInfo');
    if (userInfo) {
        const userInfoArray = userInfo.split('|');
        return {
            email: userInfoArray[6],
            firstName: userInfoArray[12],
            lastName: userInfoArray[13],
            mobile: userInfoArray[8],
            name: userInfoArray[2],
            userId: userInfoArray[0],
        };
    }

    return getUser().then((res) => {
        const { getCookie } = getCookieHelpers();
        const at = res?.access_token || getCookie('at');
        const lt = getCookie('lt');
        const { uid = '', info } = res || {};

        if (!info) return undefined;

        const { name, email, mobile, isPhNoVerified, prefix, emailVerified, fn, ln, rpr } = info;
        const userInfoStr = `${uid}|${at}|${name}||||${email}|${lt}|${mobile}|${isPhNoVerified}|${prefix}|${emailVerified}|${fn}|${ln}|${!!rpr}|${Date.now()}`;

        localStorage.setItem('userInfo', userInfoStr);
        return {
            email,
            firstName: fn,
            lastName: ln,
            mobile,
            name,
            userId: uid,
        };
    });
};
